module.exports = __webpack_public_path__ + "static/media/media.bbf767b1.svg";